import createImmutablePathReducer from "../../create-immutable-path-reducer";
import addTo from "../immutable/add-to";
export default createImmutablePathReducer(addTo);
